// extracted by mini-css-extract-plugin
export var homepage = "Home-module__homepage--1rB4h";